var TaxReportModule = (function () {
    function TaxReportModule() {
    }
    return TaxReportModule;
}());
export { TaxReportModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.module.ts.pre-build-optimizer.js